import React, { FC, PropsWithChildren, useContext, useMemo, useState } from "react";

interface IDetailContext {
    onTogglePanelOpen: (detailPanel: string) => void;
    detailPanelOpen: string;
}

export const DetailPanelsContext = React.createContext(null);
DetailPanelsContext.displayName = "DetailPanelsContext";

export const useDetailPanels = () => useContext(DetailPanelsContext);

type DetailPanelProps = {
    defaultDetailPanelOpen?: string;
};

const DetailPanels: FC<PropsWithChildren<DetailPanelProps>> = ({ children, defaultDetailPanelOpen }) => {
    const [detailPanelOpen, setDetailPanelOpen] = useState(defaultDetailPanelOpen);

    const handleTogglePanelOpen = (detailPanel: string) => {
        if (detailPanelOpen === detailPanel) {
            setDetailPanelOpen(null);
        } else {
            setDetailPanelOpen(detailPanel);
        }
    };

    const contextValue = useMemo(
        (): IDetailContext => ({
            detailPanelOpen,
            onTogglePanelOpen: handleTogglePanelOpen,
        }),
        [detailPanelOpen],
    );

    return <DetailPanelsContext.Provider value={contextValue}>{children}</DetailPanelsContext.Provider>;
};

export default DetailPanels;
